export const parseQuantity = (text: string) => {
  const n = parseInt(text, 10);
  return Number.isFinite(n) && n >= 1 ? n : null;
};

export const parsePrice = (text: string) => {
  const n = parseFloat(text);
  return Number.isFinite(n) && n >= 0 ? n : null;
};
